module.exports = __webpack_public_path__ + "static/media/windows.b80e3f39.png";